var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChevronForward(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 7,
    height: 12,
    viewBox: "0 0 7 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.35135 5.67568L0 1.32432L1.32432 0L7 5.67568L1.32432 11.3514L0 10.027L4.35135 5.67568Z",
    fill: "#F8FFF8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronForward);
export default __webpack_public_path__ + "static/media/chevron_forward.ccfd3170bec227521977615bb664f781.svg";
export { ForwardRef as ReactComponent };